/* global define BASE_PLUGIN_URL BASE_AMP_URL $ */
import { extend, throttle,
      get, assign }               from '_';
import Reflux                     from 'reflux';
import { isMobile, isIpad, envCheck,
        isLocal, imageServer }    from 'utils/util';
import VideoApi                   from 'video/video-api';
import videoConfig                from 'video/config';
import MediaStore                 from 'mixins/media_store';
import StoreState                 from 'mixins/store_state';
import VideoActions               from 'actions/video_actions';
import DescriptorStore            from 'stores/descriptor_store';
import RoadBlockStore             from 'stores/roadblock_store';
import HasPrettyTime              from 'mixins/has_pretty_time';
import EventCompiler              from 'descriptor/event_compiler';

export default Reflux.createStore({
  listenables: VideoActions,
  mixins: [ StoreState, MediaStore, HasPrettyTime ],
  stateNamespace: 'video',
  queued: [ ],
  cors_flag: true,
  mediaApi: null,
  getInitialState() {
    return {
      isVideo: true
    };
  },
  onLoad(elementId, video) {
    const descriptor = DescriptorStore.getDescriptor(),
        index      = descriptor.initialIndex,
        ampPath    = '/amp-premier/',
        pluginPath = `${ampPath}plugins/`,
        ampURL     = isLocal()? ampPath : `//img${envCheck()}.medscape.com/pi/core${ampPath}`,
        pluginURL  = isLocal()? pluginPath : `//img${envCheck()}.medscape.com/pi/core${pluginPath}`,
        watermark  = descriptor.watermark ? descriptor.watermark:'',
        config     = extend(videoConfig(pluginURL, ampURL), {
          media: video,
          debug: false,
          autoplay: video.autoplay,
          controls: {
            'native': (isMobile() && !isIpad()),
             mode: (isMobile() && !isIpad()) ? 'auto' : 'none'
          },
          branding: {
            id: 'logo',
            logo: watermark
          },
          playoverlay: { enabled: true },
          captioning:  { enabled: true },
          webmd: {
            chapterData: descriptor.videos[descriptor.initialIndex || 0].chapters
          },
          mode: 'html'
        });
    config.flash        = config.flash || { };
    config.flash.params = { wmmode: 'transparent' };
    if(this.mediaApi) {
      this.removeMediaEvents();
      this.mediaApi.destroy();
    }
    this.mediaApi = new VideoApi(elementId, config);
    this.mediaApi.init(() => {
      // autoplay if configed or if the starting video is not the
      // first in the chapter list.
      this.mediaApi._v.setAutoplay(config.autoplay && !this.state.stopAutoplay);
      this.addMediaEvents();
      if(isMobile() && !isIpad()) {
        const ccFileName = DescriptorStore.getCCInfo()[DescriptorStore.getCCDefaultLang()];
        if(typeof ccFileName !== 'undefined') {
          this.mediaApi._v.getMediaElement().addTextTrack('subtitles', 'en', 'en');
        }
      }
    });
    this.mediaApi.ready(this.onReady.bind(this));
    this.eventCompiler = new EventCompiler(get(video, 'events', []), '').compile();
    this.isBuffering = false;
    this.bufferDelay = 400;
    this.bufferTimeout = null;
    const videoWithEvents = assign(video, this.eventCompiler.getEvents());
    this.setState({
      meta: videoWithEvents,
      index: index,
      event: 'loading',
      isLoading: false,
      viewed: { },
      playerType: this.mediaApi._v.getPlayerType()
    });
    // const videoElement = this.mediaApi._v.getMediaElement();
    this.videoPosterClass = 'akamai-poster';
    this.posterImgClass = 'akamai-poster-image';
    // DEBUG REMOVEME
    window.mediaApi = this.mediaApi;
  },
  getPosterElement(ele) {
      const backgroundPath = this.mediaApi._config.media.poster;
      const akamaiSelector = '.akamai-media-element';
      if(!$('.' + this.videoPosterClass)[0]) {
        // build poster element for mobile based on desktop markup.
        if(isMobile() && $(akamaiSelector).length > 0) {
          this.posterElement = $(`<div class="${this.videoPosterClass} akamai-layer" id="mobile-poster-content"><div class="akamai-poster-content">
                <img src="${backgroundPath}" class="${this.posterImgClass}"></div>
           </div>`).insertAfter($('.akamai-video'));
           $('#mobile-poster-content').bind('touchstart', (e)=>{
             if(this.mediaApi._v.paused === true) {
               this.mediaApi.play();
             }
           })
        } else {
            window.requestAnimationFrame(this.getPosterElement.bind(null, ele));
        }
      } else {
          this.videoElement = ele;
          this.posterElement = $('.' + this.videoPosterClass);
          this.currentIndex = this.state.index;
      }
  },
  updatePosterElement(imagePath) {
    $('.' + this.posterImgClass).attr('src', imagePath);
  },
  exitFullScreenMobile() {
    if(!isIpad() && isMobile()) {
      this.mediaApi.exitFullScreen();
    }
  },
  loadMobileCC() {
    if((isMobile() && !isIpad()) && this.ccLoaded !== true) {
      const ccFileName = DescriptorStore.getCCInfo()[DescriptorStore.getCCDefaultLang()];
      if(typeof ccFileName !== 'undefined') {
        const trackUrl     = `${imageServer(envCheck())}/${DescriptorStore.getCCFileRoot().replace(/^en\//, '')}${ccFileName}`.replace('.xml', '.vtt'),
              videoElement = this.mediaApi._v.getMediaElement(),
              track        = document.createElement('track');

        videoElement.setAttribute('crossorigin', 'anonymous');
        this.ccLoaded = true;
        track.kind    = 'captions';
        track.srclang = 'en';
        track.src     = trackUrl;
        track.id      = 'captions';
        if(document.getElementById('captions') === null) {
          videoElement.appendChild(track);
        }
        videoElement.mode = 'hidden';
        videoElement.textTracks[0].mode = 'hidden';
      }
    }
  },
  // webkit only event
  onWebkitendfullscreen(videoElement) {
    if(isMobile() && !isIpad()) {
      if(!$(videoElement).attr('controls')){
        $(videoElement).attr('controls', 'controls');
      }
    }
  },
  onReady() {
    this._setupFullScreenIdleDetection();
    const meta = DescriptorStore.getVideo(this.state.index);
    this._isReady = true;
    this.setState({
               index: this.state.index,
                 api: this.mediaApi,
               event: 'ready',
           isLoading: false,
         isBuffering: false,
           isPlaying: false,
         currentTime: this.mediaApi.getCurrentTime(),
            duration: meta.duration || this.mediaApi.getDuration() || 0,
                meta: meta,
      isCaptioningOn: meta.hasCcAutoDisplay,
              ccLang: meta.ccDefaultLang,
          playerType: this.mediaApi._v.getPlayerType()
    });

    this.dequeue();
    // moved from the end of the onLoad event
    const videoElement = this.mediaApi._v.getMediaElement();
    if(get(akamai, 'amp.AMP.players.html.prototype.presentationModeChanged', null) !== null) {
      akamai.amp.AMP.players.html.prototype.presentationModeChanged = function() {};
    }
    videoElement.addEventListener('timeupdate', ()=> {
      const roadBlockedTime = RoadBlockStore.getRoadBlockedTime();
        if(videoElement.currentTime > roadBlockedTime) {
          videoElement.currentTime = roadBlockedTime;
            for(let i =0; i < videoElement.buffered.length; i++) {
              if (videoElement.buffered.start(i) <= roadBlockedTime && roadBlockedTime <= videoElement.buffered.end(i)) {
                window.trackingEnabled = false;
                this.onPause();
                this.exitFullScreenMobile();
              }
            }
        }
    });
    videoElement.addEventListener('webkitendfullscreen', this.onWebkitendfullscreen.bind(null, videoElement));
    this.getPosterElement(videoElement);
  },
  onStopAutoplay() {
    this.setState({
      stopAutoplay: true
    });
  },
  onSelectVideo(video, index) {
    if(!video.autoplay) this.posterElement.hide();
    if(isMobile()) this.updatePosterElement(video.poster);
    this.firstPause = false;
    this.eventCompiler = new EventCompiler(get(video, 'events', []), '').compile();
    const videoWithEvents = assign(video, this.eventCompiler.getEvents());
    $('#captions').remove();
    this.ccLoaded = false;
    $('video').removeAttr('crossorigin');
    if(!this._isReady) {
      this.enqueue('onSelectVideo', video, index);
      return;
    }
    this.mediaApi.setMedia(video);
    this.setState({
          index: index,
           meta: videoWithEvents,
      isPlaying: true,
      isLoading: false,
        isEnded: false,
          event: 'videoSelected'
    });
  },
  setVideoTime: throttle((newTime, mediaApi)=> {
      mediaApi.setCurrentTime(newTime);
    }, 500,  {
     'leading': true,
    'trailing': false
  }),
  onSetCurrentTime(time) {
    if(isIpad() && !this.state.hasStarted) {
      this.mediaApi.play();
    }
    const roadBlockedTime = RoadBlockStore.getRoadBlockedTime(),
      meta = DescriptorStore.getVideo(this.state.index);
      let newTime = (time > roadBlockedTime) ? roadBlockedTime : time;
      newTime = (time > this.state.duration) ? this.state.duration - 1 : newTime;
    this.clearQueue('onSetCurrentTime');
    this.setVideoTime.call(this, newTime, this.mediaApi);
    if(!this.state.isPlaying) {
      this.enqueue('onSetCurrentTime', newTime);
      this.setState({
              event: 'settingTime',
         pushedTime: newTime,
        currentTime: newTime,
          isLoading: true,
           duration: meta.duration
      });
      return;
    }
    // on the first load of a video, the duration isn't set and
    // setting the current time doesn't work until the player has
    // started. Because Akamai makes shitty, fragile APIs. This also
    // has the effect of setting the time optimistically. `pushedTime`
    // is cleared by the progress event.
    this.setState({
            event: 'settingTime',
       pushedTime: newTime,
      currentTime: newTime,
        isLoading: true,
         duration: this.mediaApi.getDuration()
    });
  },
  onBuffering() {
    if(this.isBuffering) return;
    this.isBuffering = true;
    this.bufferTimeout = setTimeout(() => {
       this.isBuffering = false;
       clearTimeout(this.bufferTimeout);
    }, this.bufferDelay);
  },
  onDeleteQna(qaidFormPage) {
    const newQnas = this.state.meta.qna.filter((qna)=> {
      return qna.qaidFormPage !== qaidFormPage;
    }),
    newMeta = JSON.parse(JSON.stringify(this.state.meta));
    newMeta.qna = newQnas;
    this.setState({
      meta: newMeta
    });
  },
  onProgress() {
    let bufferredEnd = null;
    if(this.mediaApi._v.getMediaElement().readyState === 4 && this.mediaApi._v.getMediaElement().buffered.length !== 0) {
      const buffered = this.mediaApi._v.getMediaElement().buffered.length - 1;
      bufferredEnd = this.mediaApi._v.getMediaElement().buffered.end(buffered);
    }
    this.setState({
                event: 'progress',
          isBuffering: false,
            isLoading: false,
           hasStarted: true,
          // WARNING: this is commented out because the video api sends a
          // bogus 'progress' event after the video has been paused.
          // Don't set isPlaying to true inside this setState call.
          // isPlaying:   true, <---- don't do this.
          // Hopefully that will save you some debugging time in the future.
           pushedTime: null,
          currentTime: this.mediaApi.getCurrentTime(),
             duration: this.mediaApi.getDuration(),
      roadblockedTime: RoadBlockStore.getRoadBlockedTime(),
         bufferredEnd: bufferredEnd
    });
  },
  onSetVolume(volume) {
    this.mediaApi._v.setVolume(volume);
  },
  onVolumeChanged() {
    this.setState({
              event: 'volumeChanged',
      currentVolume: this.mediaApi.getVolume()
    });
  },
  onMute() {
    this.mediaApi.mute();
  },
  onUnmute() {
    //this.onSetVolume(volume);
    this.mediaApi.unmute()
  },
  onSetClosedCaptioning(turnOn) {
    // fire global event for tracking
    $(window).trigger('onSetCaption', {on:turnOn});
    if(turnOn) {
      this.mediaApi.setCaptionLanguage(this.state.ccLang, true);
      this.mediaApi.turnClosedCaptionOn();
    } else {
      this.mediaApi.setCaptionLanguage('', false);
      this.mediaApi.turnClosedCaptionOff();
    }
    this.setState({
      isCaptioningOn: turnOn
    });
  },
  onSelectLanguage(lang) {
    if(lang !== '') {
      this.mediaApi.setCaptionLanguage(lang, true);
      this.setState({
        ccLang: lang,
        isOpen: false
      });
    } else {
      this.setState({
        ccLang: lang,
        isOpen: false
      });
    }
  },
  onEnd() {
  },
  onEnded() {
    this.mediaApi.end();
    this.state.viewed[this.state.index] = true;
    this.setState({
      isPlaying: false,
        isEnded: true,
          event: 'ended'
    });
    const nextVideo = DescriptorStore.getVideo(this.state.index+1);
    if(typeof nextVideo !== 'undefined' && nextVideo.autoplay === true) {
      nextVideo.muted=false;
      this.onSelectVideo(nextVideo, this.state.index+1);
    }
    if(isMobile()) {
      if($('.qna-container').length > 0) {
        $('.video-player-standalone').hide();
        $('.qna-container').addClass('bp_video_scroll');
      }
    }
  },
  onReplay() {
    window.trackingEnabled = false;
    this.mediaApi.replay();
    // the duration gets wiped after the video ends so we have to go back to the config.
    this.setState({
       isPlaying: true,
        duration: this.getDuration(true),
      hasStarted: true, // always true after the first start
         isEnded: false,
         canPlay: false
    });
  },
  onStart() {
    this.mediaApi.play();
    this.loadMobileCC();
    if(!this._isReady) {
      this.enqueue('onStart');
      return;
    }
    this.setState({
      event: 'start',
      isPlaying: true,
      hasStarted: true, // always true after the first start
      isLoading: true,
      isEnded: false,
      canPlay: false
    });
  },
  onStarted() {
    if(this.posterElement.css('display') === 'block') this.posterElement.hide();
    this.dequeue();
    this.loadMobileCC();
    this.setState({
          isPlaying: true,
          isLoading: false,
            isEnded: false,
              event: 'play',
         hasStarted: true,
      currentVolume: this.mediaApi.getVolume()
    });
    if(this.state.isCaptioningOn) {
      this.mediaApi.setCaptionLanguage(this.state.ccLang, true);
      this.mediaApi.turnClosedCaptionOn();
    }
  },
  onToggle() {
    if(this.isPlaying()) {
      this.onPause();
    } else {
      this.onStart();
    }
  },
  getIndex() {
    return this.state.index;
  },
  /* accessors */
  isPlaying() {
    return this.state.isPlaying;
  },
  getCurrentTime() {
    if(!this._isReady) return 0;
    return this.mediaApi.getCurrentTime();
  },
  getDuration() {
    return this.mediaApi.getDuration();
  },
  getTitle() {
    return DescriptorStore.getTitle(this.state.index);
  },
  getVersion() {
    return 'Medscape/AMP';
  }
});



// WEBPACK FOOTER //
// ./modules/stores/video_store.js